<div>{{ getRatingString() | translate }}</div>
<div layout-horizontal margin-top-small-xx>
  <ng-container *ngFor="let line of lines; trackBy: trackByIndex">
    <span [class.full]="line" class="line"> </span>
  </ng-container>
</div>
